import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { installClientLogBuffer } from "./lib/board/clientLogBuffer";
import { installEnterToConfirm } from "./lib/enterToConfirm";
import { installPerfProbe } from "./lib/board/perfProbe";
import "./styles/bezpart-header.css";
import "./styles/wb-app.css";
import "./styles/home.css";
import "./styles/auth.css";
import "./styles/board-editor.css";
import "./styles/tool-cursors.css";
import "./styles/board-zoom.css";
import "./styles/board-comments.css";
import "./styles/cabinet.css";
import "./styles/pages.css";
// Фирменный слой идёт ПОСЛЕДНИМ: он выигрывает порядком, а не !important.
import "./styles/bezpart-brand.css";

/* Метка живого скрипта. Ставится ДО отрисовки: появление блоков прячет
   их только при ней, и без метки страница без JS осталась бы пустой
   навсегда — а главную индексируют поисковики. */
document.documentElement.classList.add("js");


installClientLogBuffer();
// Enter в открытом окне нажимает его главную кнопку.
installEnterToConfirm();
// Подвисания страницы — для отчёта «Проблема».
installPerfProbe();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
